<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6>
							<button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
							New Deposit
						</h6>
					</div>
					<div class="card-body">
						<form @submit.prevent="onSubmit">
							<div v-if="message" class="alert alert-danger">{{ message }}</div>
							<div class="form-group row">
								   <div class="col-md-6">
									   <label for="bankSelect" class="col-form-label">Payment <span class="text-danger">*</span></label>
									   <select v-model="bankRequest.bank_info_id" @blur="validationRule()" class="form-control" id="bankSelect">
										   <option value="">Select Payment</option>
										   <option v-for="bank in paymentMethod" :key="bank.id" :value="bank.id">{{ bank.name }} - {{ bank.account_number }} - {{(bank.master_name || 'BXB')}}</option>
									   </select>
									   <small class="text-danger">{{validationData.bank_info_id}}</small>
								   </div>
									<div class="col-md-6">
										<label for="inputContact" class="col-form-label">User Email OR Phone <span class="text-danger">*</span></label>
										<input type="text" v-model="bankRequest.contact" @blur="validationRule()" class="form-control" id="inputContact">
										<small class="text-danger">{{validationData.contact}}</small>
									</div>
							</div>
							<div class="form-group row">
								   <div class="col-md-6">
									   <label for="inputAmount" class="col-form-label">Amount <span class="text-danger">*</span></label>
									   <input type="number" v-model="bankRequest.amount" @blur="validationRule()" class="form-control" id="inputAmount">
									   <small class="text-danger">{{validationData.amount}}</small>
								   </div>
								   	<div class="col-md-6">
									   <label for="inputAccountNumber" class="col-form-label">Last Six Digits <span class="text-danger">*</span></label>
									   <input type="text" v-model="bankRequest.last_six_digit" @blur="validationRule()" class="form-control" id="inputAccountNumber">
									   <small class="text-danger">{{validationData.last_six_digit}}</small>
								   </div>
								</div>

							<button type="submit" class="btn btn-primary float-save">Submit</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'depositCreate',
		metaInfo: {
            title: "Deposit Create",
            titleTemplate: "%s ← BXB",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				paymentMethod: [],
				message: "",
				bankRequest: {
					bank_info_id: "",
					last_six_digit: "",
					amount: "",
					contact: ""
				},
				validationData: {
					bank_info_id: "",
					last_six_digit: "",
					amount: "",
					contact: ""
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				depositStoreAction: 'depositStoreAction',
				paymentAction: 'paymentAction',
			}),
			async getPayments(){
				await this.paymentAction().then(res => {
					this.paymentMethod = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
				
				console.log(this.bankRequest)
				const formData = new FormData();
				formData.append('bank_info_id', this.bankRequest.bank_info_id);
				formData.append('last_six_digit', this.bankRequest.last_six_digit);
				formData.append('amount', this.bankRequest.amount);
				formData.append('contact', this.bankRequest.contact);

				await this.depositStoreAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.back()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ 
					path: 'deposit-list', 
					query: {
						page: 1, 
						orderBy: 'desc', 
						sortKey: 'created_at', 
					}
				}).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				if (this.bankRequest.bank_info_id == "") {
					this.validationData.bank_info_id = "The bank field is required."
					isValidation.push(true)
				} else {
					this.validationData.bank_info_id = ""
					isValidation.push(false)
				}
				if (this.bankRequest.last_six_digit == "") {
					this.validationData.last_six_digit = "The last six digits field is required."
					isValidation.push(true)
				} else {
					this.validationData.last_six_digit = ""
					isValidation.push(false)
				}
				if (this.bankRequest.amount == "") {
					this.validationData.amount = "The amount field is required."
					isValidation.push(true)
				} else {
					this.validationData.amount = ""
					isValidation.push(false)
				}
				if (this.bankRequest.contact == "") {
					this.validationData.contact = "The contact field is required."
					isValidation.push(true)
				} else {
					this.validationData.contact = ""
					isValidation.push(false)
				}

				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
			await this.getPayments()
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>